import Form from "react-bootstrap/Form";
import CustomAccordion from "components/CustomAccordion/CustomAccordion";
import RiskIndicator from "pages/Home/components/RiskIndicator/RiskIndicator";
import Overview from "./components/Overview/Overview";
import Assessment from "./components/Assessment/Assessment";
import NewsTrends from "./components/NewsTrends/NewsTrends";
import Related from "./components/Related/Related";
import AIRecommendedActions from "./components/AIRecommendedActions/AIRecommendedActions";
import Activity from "./components/Activity/Activity";
import styles from "./RHSWidgetModal.module.scss";

export default function RHSWidgetModal(props: { closeModal: () => {} }) {
  const { closeModal } = props;

  return (
    <div className={styles.modalOverlay} onClick={closeModal}>
      <div className={styles.modalContainer} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className="d-flex align-items-center justify-content-between pv-3">
            <h3 className="widget-title">Failure of supply chain due to geopolitical issues</h3>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary text-white flex-center">
                <i className="icon-plus text-5c mr-2"></i>
                Add to library
              </button>
              <button className="btn btn-outline-secondary text-white flex-center" onClick={closeModal}>
                <i className="icon-x text-5c mr-2"></i>
              </button>
            </div>
          </div>
        </div>
        <div className={styles.modalBody}>
          <div className="row p-3">
            <div className="col-3">
              <RiskIndicator
                title="Inherent Risk"
                description=""
                value="High"
                subValue="100"
                arrowColor="text-info"
              />
            </div>
            <div className="col-3">
              <RiskIndicator
                title="Control Effectiveness"
                description=""
                value="Medium"
                subValue="100"
                arrowColor="text-warning"
              />
            </div>
          </div>
          <div className="row mt-3 p-4 fw-300">
            <CustomAccordion item={{ key: '0', header: 'Overview' }}>
              <Overview />
            </CustomAccordion>
            <CustomAccordion item={{ key: '1', header: 'Assessment' }}>
              <Assessment />
            </CustomAccordion>
            <CustomAccordion item={{ key: '2', header: 'News & Trends' }}>
              <NewsTrends />
            </CustomAccordion>
            <CustomAccordion item={{ key: '3', header: 'Related' }}>
              <Related />
            </CustomAccordion>
            <CustomAccordion item={{ key: '4', header: 'AI Recommended Actions' }}>
              <AIRecommendedActions />
            </CustomAccordion>
            <CustomAccordion item={{ key: '5x', header: 'Activity' }}>
              <Activity />
            </CustomAccordion>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <Form>
            <div className="row p-3">
              <div className="col-11">
                <Form.Control className="bg-black" placeholder="Add a question or post an update..." />
              </div>
              <div className="col-1">
                <button className={`btn bg-color flex-center text-white ${styles.button}`}>
                  <i className="icon-navigation"></i>
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
